import React, { useState, useEffect } from 'react';
import Headline from '@components/atoms/headline/headline';
import Container from '@components/layout/container/container';
import FilterIcon from '@components/icons/filter/filter';
import CloseModal from '@components/atoms/close-modal/closeModal';
import CustomInfiniteHits from '@components/atoms/education/refinement-hits/educationRefinementHits';
import StyledEducationLibraryTemplate from './educationLibraryTemplate.style';
import EducationLibraryFilter from '../library-filter/educationLibraryFilter';

function EducationLibraryTemplate() {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 940);
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <StyledEducationLibraryTemplate>
      <Container large>
        <div className="library">
          <aside className="library__sidebar">
            {!isMobile && (
              <div className="library__head">
                <Headline>Filtern</Headline>
                <FilterIcon className="library__head-icon" />
              </div>
            )}
            <div
              className={`${isMobile && 'library__filter-modal'} ${modalIsOpen &&
                isMobile &&
                'modal--open'}`}
            >
              <div className={`${isMobile && 'library__filter-modal-inner'}`}>
                {isMobile && <CloseModal closeModal={closeModal} />}
                <EducationLibraryFilter />
              </div>
            </div>
          </aside>
          <div className="library__exercises">
            <div className="library__head">
              <Headline>Inhaltstypen</Headline>
              {isMobile && (
                <button type="button" onClick={openModal}>
                  <FilterIcon className="library__modal-icon-open" />
                </button>
              )}
            </div>
            <CustomInfiniteHits />
          </div>
        </div>
      </Container>
    </StyledEducationLibraryTemplate>
  );
}

export default EducationLibraryTemplate;
